import { render, staticRenderFns } from "./ed-homework-widget-person.vue?vue&type=template&id=66db2dde&scoped=true&"
import script from "./ed-homework-widget-person.ts?vue&type=script&lang=ts&"
export * from "./ed-homework-widget-person.ts?vue&type=script&lang=ts&"
import style0 from "./ed-homework-widget-person.scss?vue&type=style&index=0&id=66db2dde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66db2dde",
  null
  
)

export default component.exports